module.exports = __webpack_public_path__ + "static/media/use-patternfly.eee29234.png";